import { BaseModel } from '../classes/base-model';

export class EventLicense extends BaseModel {
    Id: number;
    FakeId: number;
    IsRequired: boolean;
    Name?: string;
    StaticText?: string;
    IsActive: boolean;
    Localization?: {
        Name?: string,
        StaticText?: string,
        Tr?: {
            Name?: string,
            StaticText?: string
        },
        En?: {
            Name?: string
            StaticText?: string
        }
    };
}



// WEBPACK FOOTER //
// ./src/app/models/event-license.ts